<template>
  <span
    v-for="(stageName, index) in props.stageNames"
    :key="`${index}-${stageName}`"
    class="inline-block max-w-24 truncate rounded-sm border border-info/40 bg-info/10 px-1 py-0.5 font-sans text-2xs font-semibold uppercase tracking-wide text-info"
    :title="stageName"
  >{{ stageName }}</span>
</template>

<script setup lang="ts">
export interface BuildStageBadgesProps {
  readonly stageNames: ReadonlyArray<string>
}

const props = defineProps<BuildStageBadgesProps>()
</script>
